import client from '../../client';

const endpoint = '/v2/matching/brands';


/**
 * Get the brands from the backend for the matching module.
 * For more information please read the backend docs.
 */
export function get(params) {
  return client.get(endpoint, { params }).then(({ data }) => data)
}


export default {
  get,
}
